import React, { Fragment } from 'react'

// components
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'

// icons
import { faBars, faFileExcel, faPlus, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// router
import { withRouter } from 'react-router-dom'

// Sweet alert
import useFamily from './hooks/useFamily'
import { getTemplate } from '../../Services/reporteService'
import Swal from 'sweetalert2'

const AddFamiliaImportar = ({ history }) => {
    const { loading, addFamiliaSubmit, setFile, file } = useFamily()

    const handleDownloadTemplate = async () => {
        try {
            const template = await getTemplate('familias')
            const byteCharacters = atob(template.data)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = 'template-familias.xlsx'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al descargar el template.',
                showConfirmButton: true,
            })
        }
    }

    return (
        <Fragment>
            <Header />

            {loading && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        color: '#fff',
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                    }}
                >
                    <div
                        className="spinner-border text-light mb-3"
                        role="status"
                        style={{ width: '4rem', height: '4rem' }}
                    ></div>
                    Importando familias...
                </div>
            )}

            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faBars} title={'Importar Familias'} />
                </div>

                <div className="bg-gris p-4">
                    <form
                        onSubmit={addFamiliaSubmit}
                        encType="multipart/form-data"
                    >
                        <div className="form-row justify-content-center">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputFile">
                                    Seleccione un archivo
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faFileExcel} />
                                    </span>
                                    <input
                                        type="file"
                                        id="inputFile"
                                        name="fileCSV"
                                        className="form-control"
                                        onChange={(e) =>
                                            setFile(e.target.files[0])
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="text-center">
                            <button
                                type="button"
                                className="btn btn-outline-primary mr-2"
                                onClick={handleDownloadTemplate}
                            >
                                <FontAwesomeIcon icon={faDownload} /> Plantilla
                            </button>
                            <button
                                type="submit"
                                className="btn btn-outline-success"
                                disabled={!file}
                                style={{ backgroundColor: !file ? '#ccc' : '' }}
                            >
                                <FontAwesomeIcon icon={faPlus} /> Importar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(AddFamiliaImportar)
